"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpen = void 0;
var react_1 = require("react");
var useOpen = function (onOpen, onClose) {
    var _a = react_1.useState(false), open = _a[0], setOpen = _a[1];
    var previousState = react_1.useRef(undefined);
    var handleOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
    };
    var toggleOpen = function () {
        setOpen(!open);
    };
    react_1.useEffect(function () {
        if (previousState.current === false && open && onOpen !== undefined) {
            onOpen();
        }
        if (previousState.current === true && !open && onClose !== undefined) {
            onClose();
        }
        previousState.current = open;
    }, [onClose, onOpen, open]);
    return { handleClose: handleClose, handleOpen: handleOpen, open: open, toggleOpen: toggleOpen };
};
exports.useOpen = useOpen;
